import { render } from "./CenterPage.vue?vue&type=template&id=598a8821&ts=true"
import script from "./CenterPage.vue?vue&type=script&lang=ts"
export * from "./CenterPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/System/Centers/CenterPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "598a8821"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('598a8821', __exports__)) {
    api.reload('598a8821', __exports__)
  }
  
  module.hot.accept("./CenterPage.vue?vue&type=template&id=598a8821&ts=true", () => {
    api.rerender('598a8821', render)
  })

}


export default __exports__